module.exports = __webpack_public_path__ + "static/media/rm7.4adb2503.jpg";